export default __webpack_public_path__ + "logo-webshop-award-5cdb8b796b3e29d7ab00dd0a16dccf17.svg";